<template>
  <div class="ladding web-bg">
    <background></background>
    <div class="header">
      <div class="index_container custom-container-xl">
        <v-layout row wrap fill-height align-center>
          <v-flex class="header__wrap" xs12 md5>
            <h1 class="header__text">
              <div class="header__title">ASTRORG</div>
              <div class="header__sub">INTERCONNECTED ECOSYSTEM</div>
              <div class="header__content">专属于你的随身占星师</div>
              <div
                class="header__btn cta-btn"
                @click="goToSection('singlePan')"
              >
                深入了解
              </div>
            </h1>
          </v-flex>
          <v-flex xs12 md7 fill-height class="header-pan">
            <img
              src="@/assets/WebPage/header-pan.svg"
              class="header_bg"
              alt="header"
            />
          </v-flex>
        </v-layout>
      </div>
    </div>

    <div class="services">
      <div class="index_container custom-container-xl">
        <v-layout row fill-height align-center class="services__container">
          <div class="services__wrap">
            <v-layout class="services__item" align-center justify-center column>
              <a @click="goToSection('singlePan')">
                <img
                  class="services__item__img"
                  src="@/assets/WebPage/service_1.svg"
                  alt="个人星盘"
                />
              </a>
              <h2
                class="services__item__title"
                @click="goToSection('singlePan')"
              >
                星座命盤
              </h2>
              <p
                class="services__item__content hidden-sm-and-down"
                @click="goToSection('singlePan')"
              >
                提供个人本命盘及双人合盘，星座、宫位、相位全收录，占星排盘不求人。
              </p>
            </v-layout>
          </div>
          <div class="services__wrap">
            <v-layout class="services__item" align-center justify-center column>
              <a @click="goToSection('doublePan')">
                <img
                  class="services__item__img"
                  src="@/assets/WebPage/icon_couple.svg"
                  alt="双人合盘"
                />
              </a>
              <h2
                class="services__item__title"
                @click="goToSection('doublePan')"
              >
                双人合盘
              </h2>
              <p
                class="services__item__content hidden-sm-and-down"
                @click="goToSection('doublePan')"
              >
                分析两人的契合度与互动模式，快速掌握关系中的重点议题。
              </p>
            </v-layout>
          </div>
          <div class="services__wrap">
            <v-layout class="services__item" align-center justify-center column>
              <a @click="goToSection('transitPan')">
                <img
                  class="services__item__img"
                  src="@/assets/WebPage/icon_service.svg"
                  alt="推运功能"
                />
              </a>
              <h2
                class="services__item__title"
                @click="goToSection('transitPan')"
              >
                推运功能
              </h2>
              <p
                class="services__item__content hidden-sm-and-down"
                @click="goToSection('transitPan')"
              >
                观察运势节奏与时间变化，协助你安排下一步决策。
              </p>
            </v-layout>
          </div>
        </v-layout>
      </div>
    </div>

    <div id="singlePan" class="section sec-1">
      <div class="index_container custom-container-xl">
        <v-layout row wrap fill-height align-center>
          <v-flex class="sec__box flex-s" xs12 md5>
            <img
              class="oval_1"
              src="@/assets/WebPage/Oval(1)_個人星盤.svg"
              alt="装饰"
            />
            <img
              class="hidden-md-and-up"
              src="@/assets/WebPage/icon_personal.svg"
              alt="个人星盘"
            />
            <div class="sec__title">
              <img
                class="hidden-sm-and-down"
                src="@/assets/WebPage/icon_personal.svg"
                alt="个人星盘"
              />
              <h2>个人星盘</h2>
            </div>
            <p class="sec__secend">比你更懂你自己，探索自我的无限可能</p>
            <p class="sec__content">
              线上量身绘制本命盘，提供详尽的个人星座、宫位、相位等信息，深入剖析个人特质与优劣势。
            </p>
            <div class="sec__btn" @click="toSinglePan">马上使用</div>
          </v-flex>
          <v-flex class="sec__space sec__space-1" xs12 md7>
            <img
              src="@/assets/WebPage/星盤_個人星盤.png"
              class="img_main"
              alt="个人星盘"
            />
            <img
              src="@/assets/WebPage/Oval(2)_個人星盤.svg"
              class="img_side"
              alt="个人星盘细节"
            />
          </v-flex>
        </v-layout>
      </div>
    </div>

    <div id="doublePan" class="section sec-2">
      <div class="index_container custom-container-xl">
        <v-layout row wrap fill-height align-center>
          <v-flex class="sec__box" xs12 md5 order-md2>
            <img
              class="hidden-md-and-up"
              src="@/assets/WebPage/icon_couple.svg"
              alt="双人合盘"
            />
            <div class="sec__title">
              <img
                class="hidden-sm-and-down"
                src="@/assets/WebPage/icon_couple.svg"
                alt="双人合盘"
              />
              <h2>双人合盘</h2>
            </div>
            <p class="sec__secend">邂逅你的命中注定，为你解读每段缘分</p>
            <p class="sec__content">
              结合两人本命盘进行组合与占算，分析契合度与沟通模式，揭露互动关系与速配指数。
            </p>
            <div class="sec__btn" @click="toDoublePan">马上占算</div>
          </v-flex>
          <v-flex class="sec__space sec__space-2" xs12 md7 order-md1>
            <img
              src="@/assets/WebPage/couple_雙人合盤.svg"
              class="people"
              alt="双人合盘"
            />
            <img
              src="@/assets/WebPage/wave_雙人合盤.svg"
              class="wave"
              alt="双人合盘细节"
            />
          </v-flex>
        </v-layout>
      </div>
    </div>

    <div id="transitPan" class="section sec-4">
      <div class="index_container custom-container-xl">
        <v-layout row wrap fill-height align-center>
          <v-flex class="sec__box" xs12 md5 order-md2>
            <div class="sec__title">
              <span>ASTRORG</span>
            </div>
            <p class="sec__secend">你，专属的随身占星师</p>
            <p class="sec__content">
              推运功能协助你追踪趋势与转折，让你更有节奏地规划工作、感情与个人成长。
            </p>
            <div class="sec__btn" @click="toTransitPan">前往推运</div>
          </v-flex>
          <v-flex class="sec__space sec__space-4" xs12 md7 order-md1>
            <div class="cup">
              <img
                src="@/assets/WebPage/漂浮杯杯/top.png"
                class="cup_bg"
                alt="推运"
              />
              <img
                src="@/assets/WebPage/漂浮杯杯/bottom.png"
                class="cup_bottom"
                alt="底图"
              />
              <img
                src="@/assets/WebPage/漂浮杯杯/couple.svg"
                class="people"
                alt="推运细节"
              />
              <img
                src="@/assets/WebPage/漂浮杯杯/金星.svg"
                class="ball"
                alt="星体"
              />
            </div>
          </v-flex>
        </v-layout>
      </div>
      <img
        src="@/assets/WebPage/漂浮杯杯/wave_ASTRORG.svg"
        class="sec-4_bg"
        alt="波浪"
      />
    </div>

    <div class="add-line section">
      <div class="add-line__bg index_container custom-container-xl">
        <v-layout row wrap fill-height align-center>
          <v-flex class="line__box" xs12 md6 order-md2>
            <div class="social">
              <img
                v-show="social === 'FB'"
                src="@/assets/WebPage/social/icon-facebook -color.svg"
                alt="FB"
              />
              <img
                v-show="social !== 'FB'"
                @click="social = 'FB'"
                src="@/assets/WebPage/social/icon-facebook.svg"
                alt="FB"
              />
              <img
                v-show="social === 'Line'"
                src="@/assets/WebPage/social/icon-line-color.svg"
                alt="Line"
              />
              <img
                v-show="social !== 'Line'"
                @click="social = 'Line'"
                src="@/assets/WebPage/social/icon-line.svg"
                alt="Line"
              />
              <img
                v-show="social === 'IG'"
                src="@/assets/WebPage/social/icon-instagram-color.svg"
                alt="IG"
              />
              <img
                v-show="social !== 'IG'"
                @click="social = 'IG'"
                src="@/assets/WebPage/social/icon-instagram.svg"
                alt="IG"
              />
            </div>
            <div class="line__wrap" v-show="social === 'FB'">
              <div class="line__title">ASTRORG 粉丝专页</div>
              <div class="line__sub">
                占星大小事都在这，马上订阅掌握最新内容。
              </div>
              <div class="social__btn">
                <a
                  href="https://www.facebook.com/astrorg.tw/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src="@/assets/WebPage/social/icon-facebook - w.svg"
                    alt="FB"
                  />
                  马上订阅
                </a>
              </div>
            </div>
            <div class="line__wrap" v-show="social === 'Line'">
              <div class="line__title">ASTRORG LINE@</div>
              <div class="line__sub">
                加入 LINE 好友，随时查看你的星盘与提醒。
              </div>
              <div class="social__btn">
                <a
                  href="http://nav.cx/bfVg6A9"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src="@/assets/WebPage/social/icon-line - w.svg"
                    alt="Line"
                  />
                  马上加入
                </a>
              </div>
            </div>
            <div class="line__wrap" v-show="social === 'IG'">
              <div class="line__title">ASTRORG Instagram</div>
              <div class="line__sub">
                追踪最新占星内容与灵感，快速补给星知识。
              </div>
              <div class="social__btn">
                <a
                  href="https://www.instagram.com/astrorg.tw/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src="@/assets/WebPage/social/icon-instagram - w.svg"
                    alt="IG"
                  />
                  马上追踪
                </a>
              </div>
            </div>
          </v-flex>
          <v-flex class="line__img" xs12 md6>
            <img src="@/assets/WebPage/line-phone.png" alt="社群" />
          </v-flex>
        </v-layout>
      </div>
    </div>

    <div class="pan">
      <div class="index_container custom-container-xl">
        <v-layout row wrap fill-height align-center>
          <v-flex class="pan__box" xs12 md6>
            <div class="pan__wrap">
              <div class="pan__title">连接科技与星座，</div>
              <div class="pan__title">带你探索前所未有的占星体验！</div>
              <div class="pan__sub hidden-sm-and-down">
                登录后可立即开始使用完整功能。
              </div>
              <div class="pan__btn cta-btn" @click="toSinglePan">线上探索</div>
            </div>
            <img
              src="@/assets/WebPage/social/Group 6.svg"
              class="hidden-pad-down"
              alt="装饰"
            />
          </v-flex>
          <v-flex class="pan__img" xs12 md6>
            <img src="@/assets/WebPage/phone.png" alt="phone" />
          </v-flex>
        </v-layout>
      </div>
    </div>

    <div class="footer">
      <div class="index_container custom-container-xl footer__inner">
        <div class="footer__brand">
          <img src="@/assets/WebPage/logo.png" alt="ASTRORG" />
          <div class="copyright">
            Copyright © 2019 Astrorg. All rights reserved
          </div>
        </div>
        <div class="footer__links">
          <div @click="$router.push({ path: '/privacy-policy' })">
            隐私及服务条款
          </div>
          <a
            href="https://www.facebook.com/astrorg.tw/"
            target="_blank"
            rel="noreferrer"
            >Facebook</a
          >
          <a
            href="https://www.instagram.com/astrorg.tw/"
            target="_blank"
            rel="noreferrer"
            >Instagram</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import background from "@/components/webPage/background.vue";

export default {
  name: "web-index",
  components: {
    background,
  },
  data() {
    return {
      social: "FB",
    };
  },
  methods: {
    goToSection(id) {
      if (this.$vuetify && this.$vuetify.goTo) {
        this.$vuetify.goTo(`#${id}`);
        return;
      }
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    },
    pushWithLoginCheck(path) {
      if (window.localStorage.getItem("login_status")) {
        this.$router.push({ path });
      } else {
        this.$store.state.LoginOutSide = true;
      }
    },
    toSinglePan() {
      this.pushWithLoginCheck("/astrolabe");
    },
    toDoublePan() {
      const userData = this.$store.state.userData;
      if (userData && userData.HasSynastries) {
        this.$router.push({ path: "/listDBL" });
        return;
      }
      this.$router.push({ path: "/Synastry" });
    },
    toTransitPan() {
      this.pushWithLoginCheck("/timelineAstrolabe");
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css?family=Orbitron&display=swap");
@import "@/scss/_mixin.scss";
@import "@/scss/grid.scss";

.web-bg {
  background-color: #19112b;
  position: relative;
  margin-top: -60px;
  @include mobile {
    margin-top: -60px;
  }
}

.ladding {
  position: relative;
  z-index: 1;
}

.header {
  position: relative;
  height: 800px;
  padding: 0 4px;
  @include pad {
    height: 100vh;
    padding: 0;
  }

  .header__wrap {
    position: relative;
    z-index: 2;
    display: flex;
    height: 100%;
    justify-content: flex-start;
    @include pad {
      justify-content: flex-end;
      align-items: center;
      flex-direction: column;
      margin-top: 0;
      @include center;
    }

    .header__text {
      margin-top: 220px;
      text-align: left;
      align-items: flex-start;
      justify-content: center;
      display: flex;
      flex-direction: column;
      @include pad {
        margin-top: 220px !important;
        text-align: center;
        align-items: center;
        display: flex;
        padding-bottom: 30px;
      }

      .header__title {
        font-size: 80px;
        font-weight: bold;
        font-family: "Orbitron";
        letter-spacing: 1px;
        @include mobile {
          font-size: 48px;
        }
      }

      .header__sub {
        font-size: 24px;
        letter-spacing: 4.5px;
        @include mobile {
          font-size: 16px;
          letter-spacing: 3px;
        }
      }

      .header__content {
        font-size: 24px;
        margin-top: 16px;
        order: -1;
        @include pad {
          opacity: 0.8;
          margin-bottom: 30px;
        }
        @include mobile {
          font-size: 16px;
        }
      }

      .header__btn {
        margin-top: 64px;
        @include pad {
          margin-top: 180px;
        }
      }
    }
  }

  .header-pan {
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    opacity: 1;
    @include pad {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
    }

    img {
      width: 710px;
      height: 710px;
      object-fit: contain;
      @include pad {
        width: 100vw;
        height: 100%;
        opacity: 0.6;
      }
    }
  }
}

.services {
  position: relative;
  z-index: 2;
  background-color: #ffffff18;
  width: 100%;
  height: 465px;
  margin: -16px 0;
  @include pad {
    margin: 0;
    height: 182px;
  }

  .services__container {
    display: flex;
    justify-content: space-between;
    @include pad {
      flex-wrap: wrap;
    }
  }

  .services__item {
    color: #fff;

    .services__item__img {
      width: 160px;
      height: 160px;
      @include pad {
        width: 83px;
        height: 83px;
      }
    }

    .services__item__title {
      font-size: 24px;
      margin: 40px 0 32px;
      cursor: pointer;
      @include pad {
        margin: 20px 0 0 0;
      }
      @include mobile {
        font-size: 16px;
      }
    }

    .services__item__content {
      font-size: 16px;
      max-width: 288px;
      cursor: pointer;
    }
  }
}

.section {
  position: relative;
  @include center;
  height: 800px;
  @include pad {
    padding-top: 36px;
    height: auto;
  }

  .sec__box {
    position: relative;
    @media (min-width: 960px) {
      padding: 0 12px 0 60px;
    }

    .oval_1 {
      position: absolute;
      left: -50%;
      top: -87%;
      z-index: 0;
      @include pad {
        display: none;
      }
    }
    @include pad {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
    }

    .sec__title {
      position: relative;
      display: flex;
      align-items: center;

      img {
        position: absolute;
        width: 52px;
        height: 56px;
        left: -56px;
      }

      span {
        font-size: 40px;
      }
      h2 {
        font-size: 40px;
        margin: 0;
      }
    }

    .sec__secend {
      font-size: 24px;
      font-weight: 500;
      @include pad {
        font-size: 16px;
      }
    }

    .sec__content {
      margin-top: 26px;
      font-size: 16px;
      @include pad {
        width: 90vw;
        margin-top: 24px;
      }
    }

    .sec__btn {
      margin-top: 50px;
      cursor: pointer;
      @include center;
      font-size: 24px;
      width: 272px;
      height: 64px;
      border-radius: 32px;
      border: solid 2px rgba(255, 255, 255, 0.8);
      background-image: linear-gradient(145deg, #fa71cd, #c471f5);
      position: relative;
      z-index: 6;
      @include pad {
        margin-top: 32px;
      }
      @include mobile {
        font-size: 16px;
        width: 160px;
        height: 40px;
      }
    }
  }

  &.sec-4 .sec__box {
    @media (min-width: 960px) {
      padding: 0 12px 0 0;
    }
  }

  &.sec-4 .sec-4_bg {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
  }

  &.sec-4 .sec__title span {
    font-family: "Orbitron";
    font-weight: bold;
    font-size: 48px;
  }
}

.sec__space {
  &.sec__space-1 {
    position: relative;
    height: 842px;
    left: 0;
    top: 0;
    z-index: 5;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 0;
    @include pad {
      height: 495px;
      left: 0;
    }

    .img_main {
      margin-top: -17%;
      position: relative;
      z-index: 2;
      width: 100%;
      @include pad {
        height: 495px;
        width: 100vw;
        object-fit: contain;
        object-position: 50% 50%;
        margin-top: 0;
      }
    }

    .img_side {
      position: absolute;
      top: 20%;
      left: 70%;
      width: 35%;
      @include pad {
        display: none;
      }
    }
  }

  &.sec__space-2 {
    position: relative;

    .people {
      width: 100%;
      left: -16px;
      @include pad {
        width: 100vw;
      }
    }

    .wave {
      position: absolute;
      width: 70%;
      bottom: -20px;
      left: 15%;
      @include pad {
        width: 90%;
        left: 5%;
        bottom: -10px;
      }
    }
  }

  &.sec__space-4 {
    margin-top: 180px;
    display: flex;
    justify-content: center;
    @include mobile {
      margin-top: 110px;
    }

    .cup {
      width: 400px;
      height: 615px;
      position: relative;
      @include pad {
        display: flex;
        justify-content: center;
        width: 500px;
        height: 615px;
        margin-top: 100px;
      }
      @include mobile {
        width: 320px;
        height: 480px;
        margin-top: 48px;
      }

      .cup_bg {
        width: 400px;
        height: 615px;
        object-fit: cover;
        position: relative;
        z-index: 4;
        @include pad {
          width: 320px;
          height: 492px;
        }
        @include mobile {
          width: 250px;
          height: 385px;
        }
      }

      .cup_bottom {
        position: absolute;
        z-index: 2;
        @media (min-width: 960px) {
          left: -62px;
          bottom: -15px;
          width: 530px;
          height: 673px;
        }
        @include pad {
          bottom: 112px;
          width: 430px;
          height: 533px;
        }
        @include mobile {
          bottom: 84px;
          width: 330px;
          height: 410px;
        }
      }

      .people {
        max-width: 100%;
        position: absolute;
        z-index: 3;
        left: 0;
        right: 0;
        bottom: 100px;
        animation: fly 1.3s ease-in-out 2.7s infinite alternate;
        @include pad {
          bottom: 200px;
        }
        @include mobile {
          bottom: 150px;
        }
      }

      .ball {
        position: absolute;
        width: 160px;
        left: 30%;
        bottom: 500px;
        animation: fly 1.8s ease-in-out 0s infinite alternate;
        @include pad {
          width: 120px;
          bottom: 570px;
          left: 40%;
        }
        @include mobile {
          width: 88px;
          bottom: 510px;
          left: 40%;
        }
      }
    }
  }
}

@keyframes fly {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(0, -30px);
  }
}

.add-line {
  height: 500px;
  background-color: rgba(255, 255, 255, 0.1);
  position: relative;
  z-index: 1;
  @include pad {
    padding-top: 0 !important;
    background: none;
    height: auto;
  }

  .add-line__bg {
    @include pad {
      background-color: rgba(255, 255, 255, 0.15);
    }
  }

  .line__img {
    display: flex;
    justify-content: flex-end;
    padding-left: 52px;
    padding: 32px;
    @media (min-width: 960px) {
      justify-content: flex-start;
      padding: 0 16px;
    }
    @include pad {
      order: -1;
      padding: 30px 0;
      justify-content: center;
    }

    img {
      position: relative;
      top: 20px;
      z-index: 5;
      width: 100%;
      max-width: 420px;
      @media (min-width: 960px) {
        height: 500px;
        width: auto;
        object-fit: contain;
        z-index: 5;
        transform: translate(0, 30px);
      }
      @include pad {
        top: 0;
      }
    }
  }

  .line__box {
    @include pad {
      padding: 30px 0;
    }

    .social {
      display: flex;
      padding-left: 160px;
      margin-bottom: 12px;
      @include pad {
        padding-left: 0;
        justify-content: center;
      }

      img {
        width: 40px;
        margin-right: 8px;
        cursor: pointer;
      }
    }

    .line__wrap {
      display: flex;
      align-items: flex-start;
      flex-direction: column;
      padding-bottom: 0;
      padding-left: 160px;
      @include pad {
        padding-left: 0;
        align-items: center;
      }

      .line__title {
        font-size: 40px;
        font-weight: 600;
        text-align: left;
        @include pad {
          text-align: center;
        }
        @include mobile {
          font-size: 24px;
        }
      }

      .line__sub {
        font-size: 20px;
        margin: 24px 0 18px;
        text-align: left;
        @include pad {
          text-align: center;
        }
        @include mobile {
          font-size: 16px;
        }
      }

      .social__btn {
        margin-top: 50px;
        cursor: pointer;
        @include center;
        font-size: 24px;
        width: 272px;
        height: 64px;
        border-radius: 32px;
        border: solid 2px rgba(255, 255, 255, 0.8);
        background-image: linear-gradient(145deg, #fa71cd, #c471f5);
        position: relative;
        z-index: 6;
        @include pad {
          margin-top: 32px;
          font-size: 16px;
          width: 160px;
          height: 40px;
        }

        > a {
          display: flex;
          align-items: center;
          color: #fff;
          text-decoration: none;
          img {
            height: 1.5em;
            margin-right: 2px;
          }
        }
      }
    }
  }
}

.pan {
  height: 800px;
  position: relative;
  @include pad {
    height: auto;
    padding-bottom: 50px;
  }

  .pan__box {
    position: relative;

    .pan__wrap {
      position: relative;
      z-index: 5;
      @include pad {
        margin: 112px 0;
        display: flex;
        flex-direction: column;
        align-items: center;
      }

      .pan__title {
        font-size: 40px;
        @include mobile {
          font-size: 24px;
        }
      }

      .pan__sub {
        opacity: 0.5;
        font-size: 16px;
        margin: 16px 0 40px;
      }

      .pan__btn {
        @include pad {
          position: relative;
          z-index: 10;
          margin-top: 34px;
        }
      }
    }

    > img {
      position: absolute;
      z-index: 2;
      left: -108px;
      top: -240px;
    }
  }

  .pan__img {
    @include center;
    height: 100%;

    img {
      width: 70vw;
      max-width: 420px;
      @include mobile {
        width: 90vw;
      }
    }
  }
}

.cta-btn {
  width: 271px;
  height: 64px;
  border-radius: 32px;
  border: solid 2px rgba(255, 255, 255, 0.8);
  background-image: linear-gradient(145deg, #fa71cd, #c471f5);
  font-size: 24px;
  @include center;
  cursor: pointer;
  @include mobile {
    width: 160px;
    height: 40px;
    font-size: 16px;
  }
}

.footer {
  background: #000;
  min-height: 180px;
  display: flex;
  align-items: center;
  margin-top: 40px;

  .footer__inner {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    gap: 24px;
    @include pad {
      flex-direction: column;
      text-align: center;
      padding: 20px 0;
    }
  }

  .footer__brand {
    img {
      width: 120px;
    }
    .copyright {
      margin-top: 10px;
      font-size: 12px;
      opacity: 0.8;
    }
  }

  .footer__links {
    display: flex;
    gap: 18px;
    align-items: center;
    a,
    div {
      color: #fff;
      text-decoration: none;
      cursor: pointer;
      opacity: 0.85;
    }
  }
}
</style>
